import React, { useMemo, useRef, useState } from 'react';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import { useSearchParams } from 'react-router-dom';

const SortField = ({ options, params, defaultParams, label, classContainer }) => {
  const [isOpen, setIsOpen] = useState(false);

  const selectRef = useRef(null);
  const detailsRef = useRef(null);
  const [searchParams, setSearchParams] = useSearchParams();

  const currentSort = searchParams.get(params) ?? defaultParams;

  const selectedOption = useMemo(() => {
    return options?.find((option) => option.value === currentSort);
  }, [currentSort, options]);

  const handleClick = (value) => {
    if (detailsRef.current) {
      detailsRef.current.removeAttribute('open');
    }
    setSearchParams(new URLSearchParams(`?${params}=${value}`));
  };

  return (
    <>
      {isOpen && (
        <div
          className="fixed top-0 left-0 w-full h-full z-40 bg-black bg-opacity-20"
          onClick={() => {
            setIsOpen(false);
            if (detailsRef.current) {
              detailsRef.current.removeAttribute('open');
            }
          }}
        />
      )}

      <div
        className={`px-2 h-[38px] flex gap-x-2 items-center relative cursor-pointer border border-gray-300 rounded-lg bg-white ${classContainer ?? ''}`}
        ref={selectRef}>
        <details ref={detailsRef} className="relative w-full" onToggle={(e) => setIsOpen(e.currentTarget.open)}>
          <summary className="min-w-[160px] list-none text-gray-400 flex gap-x-2 items-center py-2">
            <span className={'text-sm pr-2'}>{selectedOption?.name ?? label}</span>
            <FilterAltOutlinedIcon className={'ml-auto'} />
          </summary>

          <div className="absolute font-normal left-[-8px] top-[40px] z-40 p-2 overflow-y-auto max-h-[80vh] max-w-xs bg-white rounded-xl flex flex-col">
            {options && options.length > 0
              ? options.map((option) => {
                  const { name, value } = option;
                  const selected = selectedOption?.value === value;

                  return (
                    <button
                      key={value}
                      className={`${selected ? 'bg-gray-300' : 'hover:bg-gray-100'} py-1 px-2 text-sm text-start transition-colors`}
                      disabled={selected}
                      onClick={() => handleClick(value)}>
                      {name}
                    </button>
                  );
                })
              : null}
          </div>
        </details>
      </div>
    </>
  );
};
export default SortField;
